export interface Match {
  id: number;
  league: string;
  homeTeam: string;
  awayTeam: string;
  homeScore: number | null;
  awayScore: number | null;
  time: string;
  status: 'live' | 'upcoming' | 'finished';
  category: string;
  homeLogo: string;
  awayLogo: string;
}

export const liveMatches: Match[] = [
  {
    id: 1,
    league: '英超联赛',
    homeTeam: '曼联',
    awayTeam: '利物浦',
    homeScore: 2,
    awayScore: 1,
    time: '72\'',
    status: 'live',
    category: 'football',
    homeLogo: 'ri-shield-star-line',
    awayLogo: 'ri-shield-flash-line',
  },
  {
    id: 2,
    league: 'NBA常规赛',
    homeTeam: '湖人',
    awayTeam: '勇士',
    homeScore: 98,
    awayScore: 95,
    time: 'Q4 5:32',
    status: 'live',
    category: 'basketball',
    homeLogo: 'ri-vip-crown-line',
    awayLogo: 'ri-shield-line',
  },
  {
    id: 3,
    league: 'ATP大师赛',
    homeTeam: '辛纳',
    awayTeam: '阿尔卡拉斯',
    homeScore: 1,
    awayScore: 1,
    time: '第三盘 3-2',
    status: 'live',
    category: 'tennis',
    homeLogo: 'ri-user-star-line',
    awayLogo: 'ri-user-heart-line',
  },
];

export const upcomingMatches: Match[] = [
  {
    id: 4,
    league: '欧冠联赛',
    homeTeam: '皇家马德里',
    awayTeam: '拜仁慕尼黑',
    homeScore: null,
    awayScore: null,
    time: '08月08日 03:00',
    status: 'upcoming',
    category: 'football',
    homeLogo: 'ri-vip-crown-line',
    awayLogo: 'ri-shield-star-line',
  },
  {
    id: 5,
    league: 'NBA常规赛',
    homeTeam: '凯尔特人',
    awayTeam: '雄鹿',
    homeScore: null,
    awayScore: null,
    time: '08月08日 08:30',
    status: 'upcoming',
    category: 'basketball',
    homeLogo: 'ri-leaf-line',
    awayLogo: 'ri-ancient-gate-line',
  },
  {
    id: 6,
    league: 'LPL夏季赛',
    homeTeam: 'JDG',
    awayTeam: 'BLG',
    homeScore: null,
    awayScore: null,
    time: '08月08日 17:00',
    status: 'upcoming',
    category: 'esports',
    homeLogo: 'ri-gamepad-line',
    awayLogo: 'ri-gamepad-line',
  },
  {
    id: 7,
    league: 'WTA巡回赛',
    homeTeam: '郑钦文',
    awayTeam: '萨巴伦卡',
    homeScore: null,
    awayScore: null,
    time: '08月09日 10:00',
    status: 'upcoming',
    category: 'tennis',
    homeLogo: 'ri-user-star-line',
    awayLogo: 'ri-user-heart-line',
  },
  {
    id: 8,
    league: '西甲联赛',
    homeTeam: '巴塞罗那',
    awayTeam: '马德里竞技',
    homeScore: null,
    awayScore: null,
    time: '08月09日 04:00',
    status: 'upcoming',
    category: 'football',
    homeLogo: 'ri-shield-cross-line',
    awayLogo: 'ri-shield-user-line',
  },
];